<template>
  <main>
    <section class="box">
      <p class="title">关于我们</p>
      <h2>深圳市常顺旅行社有限公司</h2>
      <div>
        <p class="MsoNormal" style="text-indent:30pt;">
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>深圳市常顺旅行社有限公司（简称</span>“常顺旅行社”），中国旅游局批准出境社许可证号：L—GD01385&nbsp;<span>正式成立于</span>2004<span>年</span>12<span>月</span>3日，注册资本为人民币750万元。
</p>
<p class="MsoNormal" style="text-indent:24pt;">
	&nbsp;
</p>
<p class="MsoNormal" style="text-indent:24pt;">
	<span>公司现有员工8</span>0<span>多人，学历大都是大专水平以上，平均年龄不到</span>30<span>岁；在北京、广州设有分公司。深圳总部现有</span>10大部门：签证部、机票部、酒店部、旅游部、操作部、资料部、电商部、财务部、大客户部、运营部；是一支业务水平高，专业知识广，服务意识强，工作经验丰富的精英团队，是经深圳市旅游局、国家旅游局认可的出境组团旅行社；
</p>
<p class="MsoNormal" style="text-indent:24pt;">
	&nbsp;<br />
&nbsp; &nbsp;常顺旅行社自成立开始，从各国签证业务为切点，与新西兰、加拿大、俄罗斯驻香港签证中心；缅甸、老挝、柬埔寨、尼泊尔等国驻香港领事馆；泰国驻广州总领事馆、印度驻广州领事馆、美国、申根各国、英国、澳大利亚等国驻广州、北京、上海、昆明等多个地区的120多个国家的领事馆和签证中心保持着良好的合作关系。
</p>
<p class="MsoNormal" style="text-indent:24pt;">
	&nbsp;
</p>
<p class="MsoNormal" style="text-indent:24pt;">
	<span>常顺旅行社经过</span>16年多的努力，由几人的小公司发展成为入境游、出境游、国内游、签证代办、酒店预订、航空票务、网络营销多业并举，在业内享有了极高的知名度，拥有了一大批多年紧密合作的客户及代理商，赢得了无数散客和上市企业的青睐和支持，竞争力不断提升。
</p>
<p class="MsoNormal">
	&nbsp;
</p>
<p class="MsoNormal" style="text-indent:24pt;">
	<span>常顺旅行社每年都为</span>30多万人次的中国人提供出国旅游、商务活动、会议策划等业务优质服务，其中60%-70%为终端客户，常顺旅行社是深圳地区出国旅游服务批发商。
</p>
<p class="MsoNormal" style="text-indent:24pt;">
	&nbsp;
</p>
<p class="MsoNormal" style="text-indent:24pt;">
	<span>常顺旅行社坚持走诚信经营的道路，常顺旅行社坚持走诚信经营的道路，从未发生投诉案例，同时成为深圳市文旅协会副会长、深圳市企业家协会副会长、深圳市楚商协会副长、深圳市旅游协会常务理事单位；荣获</span>2017年印度国家旅游局频发印度旅游产品前十名、荣获2018年新加坡国家旅游局频发新加坡会奖旅游最具潜力奖。
</p>
<p class="MsoNormal" style="text-indent:24pt;">
	&nbsp;
</p>
<p class="MsoNormal" style="text-indent:24pt;">
	<span>常顺旅行社于</span>2016年9月1日正式开发上线常顺ERP企业管理系统，这套ERP管理系统直接与小程序、B2C、B2B、微商API数据对接。借助常顺旅行平台，公司大力发展商旅客户，62位常顺旅行社销售人员每天奔走在深圳市各大社区和有出国需求的公司，面对面推销出境旅游产品，为公司提供了大量的出国旅游客源。
</p>
<p class="MsoNormal">
	&nbsp;
</p>
<p class="MsoNormal" style="text-indent:30pt;">
	<span>作为旅游服务行业中的一员，常顺旅行社以</span>“满足客户需求为己任，以诚信经营为准则，以高效卓越为追求”作为经营理念，以“尊重对手，尊重市场，合作双赢，共同发展”作为公司与同业合作的基本原则，坚持努力将客户体验放在第一位，不断提高产品质量和服务水平，让客户尽量少花钱，少花精力就能享受到我们公司的优质服务，体验到办理旅行手续过程的便利。
</p>
<p class="MsoNormal" style="text-indent:30pt;">
	在公司内部管理中，常顺旅行社将以人为本的理念作为公司发展的根本，以公司所有员工的智慧作为公司发展的保障。坚持公司发展依靠员工，公司发展成果由员工共享的原则，使公司在激烈竞争的旅游市场中能自由的翱翔。
</p>
<p class="MsoNormal" style="text-indent:30pt;">
	<span>未来，品牌化建设、网络化、数据化发展将是常顺旅行社发展战略的重点，</span>&nbsp;ERP系统可将公司多年经营的各种数据进行分析，常顺旅行社将利用这些有效的数据为企业和广大客户提供更经济，更便捷，更安全，更优质的服务。
</p>
<p class="MsoNormal" style="text-indent:24pt;">
	展望未来，常顺旅行社所有员工信心百倍，我们坚信在广大客户一如既往的信任和支持之下，我们有能力把公司建设成为深圳旅游业的明星企业，也一定能在中国旅游行业中创造辉煌！
</p>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  created () {
    this.scrollTo();
  }
}
</script>

<style>
main {
  background: #fff;
  .box {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto 30px;
    line-height: 2;
    .title {
      display: flex;
      align-items: center;
      height: 40px;
      margin: 30px 0 0;
      font-size: var(--fs_l);
      font-weight: bold;
      color: var(--main);
      border-bottom: 1px solid var(--bdr_light);
    }
    h2 {
      text-align: center;
      font-size: var(--fs_xl);
      font-weight: bold;
      color: var(--txt_bold);
      margin: 20px 0 20px;
    }
  }
}
</style>